import useVesselOwnerForm from "../../Libs/useVesselOwnerFrom";
import { ReactComponent as BlackVatugIcon } from "../../../Asset/black.svg";
import React, { Fragment, useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import "./createprofile_step_1.css";

const CreateProfileStepOne = () => {
  const { 
    formDatas, 
    handleInputChange, 
    handleFormSubmit, 
    handleSelectionChange, 
    removeSelection 
  } = useVesselOwnerForm();
  
  const navigate = useNavigate();

  // State for phone input
  const [phoneNumber, setPhoneNumber] = useState('');

  // State for custom dropdowns
  const [isServiceCategoryOpen, setIsServiceCategoryOpen] = useState(false);
  const [isKeywordsOpen, setIsKeywordsOpen] = useState(false);
  
  // Search terms for dropdowns
  const [serviceCategorySearchTerm, setServiceCategorySearchTerm] = useState('');
  const [keywordsSearchTerm, setKeywordsSearchTerm] = useState('');
  
  // Refs for click outside handling
  const serviceCategoryRef = useRef(null);
  const keywordsRef = useRef(null);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (serviceCategoryRef.current && !serviceCategoryRef.current.contains(event.target)) {
        setIsServiceCategoryOpen(false);
      }
      if (keywordsRef.current && !keywordsRef.current.contains(event.target)) {
        setIsKeywordsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const serviceCategories = [
    "Anchor Handling & Towing", "Offshore Supply", "DP Operations",
    "Deck Cargo & Heavy Lift", "Bulk Cargo Handling", "Crew & Personnel Transfer",
    "Emergency Response", "Shallow Water Operations", "High-Speed Offshore Support",
    "Barge & Towage", "Marine Transport", "Fuel & Bunkering",
    "Marine Construction", "Vessel Chartering", "Subsea Maintenance",
    "Tanker Pursue", "Security Escort"
  ];

  const keywords = [
    "Bollard Pull", "Anchor Handling", "Towing", "Winch",
    "Dynamic Positioning (DP)", "Cargo Capacity", "Deck Load", "Liquid Mud",
    "Dry Bulk", "Speed", "Crew Transfer", "Emergency Response",
    "Shallow Draft", "High-Speed Transfer", "Rapid Deployment",
    "Fuel Efficiency", "Flat-Deck", "Towage", "Transport Capacity"
  ];

  // Handle phone input changes
  const handlePhoneChange = (value, country) => {
    setPhoneNumber(value);
    // Extract only the number part without country code for backend
    const numberOnly = value.replace(`+${country.dialCode}`, '');
    // Update the form data with just the number
    handleInputChange({
      target: {
        name: 'phoneNumber',
        value: numberOnly
      }
    });
  };

  // Toggle functions for dropdowns
  const toggleServiceCategoryDropdown = () => {
    setIsServiceCategoryOpen(!isServiceCategoryOpen);
    // Close other dropdowns
    setIsKeywordsOpen(false);
  };

  const toggleKeywordsDropdown = () => {
    setIsKeywordsOpen(!isKeywordsOpen);
    // Close other dropdowns
    setIsServiceCategoryOpen(false);
  };

  // Handler for service category selection
  const handleServiceCategorySelect = (category) => {
    handleSelectionChange("serviceCategory", category);
    setIsServiceCategoryOpen(false);
    setServiceCategorySearchTerm('');
    
    // Force state update
    setTimeout(() => {
      setIsServiceCategoryOpen(false);
    }, 0);
  };

  // Handler for keywords selection
  const handleKeywordsSelect = (keyword) => {
    handleSelectionChange("keywords", keyword);
    setIsKeywordsOpen(false);
    setKeywordsSearchTerm('');
    
    // Force state update
    setTimeout(() => {
      setIsKeywordsOpen(false);
    }, 0);
  };

  // Filter options based on search terms
  const filteredServiceCategories = serviceCategories.filter(category => 
    category.toLowerCase().includes(serviceCategorySearchTerm.toLowerCase())
  );

  const filteredKeywords = keywords.filter(keyword => 
    keyword.toLowerCase().includes(keywordsSearchTerm.toLowerCase())
  );

  const handleNextClick = (e) => {
    e.preventDefault();
    if (formDatas.serviceCategory.length < 2 || formDatas.keywords.length < 2) {
      toast.error("Please select at least 2 service categories and 2 keywords.");
      return;
    }
    handleFormSubmit(e);
    navigate("/createprofile_step_2");
  };

  return (
    <Fragment>
      <ToastContainer />
      <div className="customer-active-container">
        <div className="wrap">
          <div className="header">
            <span>
              <BlackVatugIcon onClick={() => navigate("/")} className="ioc"/>
            </span>
          </div>
        </div>

        <form onSubmit={handleNextClick}>
          <h2>Company Details</h2>

          <label>Company Name
            <input 
              type="text" 
              name="companyName" 
              value={formDatas.companyName} 
              onChange={handleInputChange} 
              required 
            />
          </label>

          <label>Years in Operation
            <input 
              type="text" 
              name="yearsInOperation" 
              value={formDatas.yearsInOperation} 
              onChange={handleInputChange} 
              required 
            />
          </label>

          <label>Registration Number
            <input 
              type="text" 
              name="registrationNumber" 
              value={formDatas.registrationNumber} 
              onChange={handleInputChange} 
              required 
            />
          </label>

          <label>Website
            <input 
              type="url" 
              name="website" 
              value={formDatas.website} 
              onChange={handleInputChange} 
              required 
            />
          </label>

          <label>LinkedIn
            <input 
              type="url" 
              name="linkedIn" 
              value={formDatas.linkedIn} 
              onChange={handleInputChange} 
              required 
            />
          </label>

          <label>Phone Number
            <PhoneInput
              country={'ng'}
              value={phoneNumber}
              onChange={handlePhoneChange}
              inputProps={{
                name: 'phoneNumber',
                required: true,
                autoFocus: true
              }}
              containerClass="phone-input-container"
              inputClass="phone-input"
              buttonClass="phone-input-button"
              dropdownClass="phone-input-dropdown"
              searchClass="phone-input-search"
            />
          </label>

          <label>Service Category (min 2)
            <div className="custom-select-container" ref={serviceCategoryRef}>
              <button 
                type="button"
                className="custom-select-button"
                onClick={toggleServiceCategoryDropdown}
              >
                Select Service Category
              </button>
              {isServiceCategoryOpen && (
                <div className="custom-select-dropdown show">
                  <div className="custom-select-search">
                    <input
                      type="text"
                      placeholder="Search service categories..."
                      value={serviceCategorySearchTerm}
                      onChange={(e) => setServiceCategorySearchTerm(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                  {filteredServiceCategories.length > 0 ? (
                    filteredServiceCategories.map((category, index) => (
                      <div
                        key={index}
                        className={`custom-select-option ${formDatas.serviceCategory.includes(category) ? 'selected' : ''}`}
                        onClick={() => handleServiceCategorySelect(category)}
                      >
                        {category}
                      </div>
                    ))
                  ) : (
                    <div className="custom-select-option">No service categories available</div>
                  )}
                </div>
              )}
            </div>
            <div className="selected-items">
              {formDatas.serviceCategory.map((category, index) => (
                <span key={index} className="selected-item">
                  {category} 
                  <button 
                    type="button" 
                    onClick={() => removeSelection("serviceCategory", category)}
                  >
                    −
                  </button>
                </span>
              ))}
            </div>
          </label>

          <label>Keywords (min 2)
            <div className="custom-select-container" ref={keywordsRef}>
              <button 
                type="button"
                className="custom-select-button"
                onClick={toggleKeywordsDropdown}
              >
                Select Keywords
              </button>
              {isKeywordsOpen && (
                <div className="custom-select-dropdown show">
                  <div className="custom-select-search">
                    <input
                      type="text"
                      placeholder="Search keywords..."
                      value={keywordsSearchTerm}
                      onChange={(e) => setKeywordsSearchTerm(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                  {filteredKeywords.length > 0 ? (
                    filteredKeywords.map((keyword, index) => (
                      <div
                        key={index}
                        className={`custom-select-option ${formDatas.keywords.includes(keyword) ? 'selected' : ''}`}
                        onClick={() => handleKeywordsSelect(keyword)}
                      >
                        {keyword}
                      </div>
                    ))
                  ) : (
                    <div className="custom-select-option">No keywords available</div>
                  )}
                </div>
              )}
            </div>
            <div className="selected-items">
              {formDatas.keywords.map((keyword, index) => (
                <span key={index} className="selected-item">
                  {keyword} 
                  <button 
                    type="button" 
                    onClick={() => removeSelection("keywords", keyword)}
                  >
                    −
                  </button>
                </span>
              ))}
            </div>
          </label>

          <button type="submit">Next</button>
        </form>
      </div>
    </Fragment>
  );
};

export default CreateProfileStepOne;